import React from "react";
import {Button} from "@mui/material";
import {ReactComponent as CloseIcon} from "../../assets/close_icon.svg";
import {makeStyles} from "@mui/styles";

const useStyles = makeStyles(() => ({
  closePopupBtn: {
    '&.MuiButton-root': {
      padding: `6px`,
      '& > svg > path': {
        fill: `#ffffff`
      },
      '&:hover': {
        backgroundColor: `#ffffff80`,
        '& > svg > path': {
          fill: `#000000`
        },
      }
    }
  }
}))


interface Props {
  onClose: VoidFunction;
}

export const ClosePopupBtn: React.FC<Props> = ({
                                                 onClose
                                               }) => {
  const classes = useStyles();
  return (
    <Button className={classes.closePopupBtn} onClick={onClose}>
      <CloseIcon/>
    </Button>
  )
}